import { GetActivoByIdDtoProps } from "api/DTOs/GetActivoByIdDto"
import {
  ErrorMessage,
  Field,
  FormikErrors,
  FormikHandlers,
  FormikState,
} from "formik"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

interface AssetDetailProps {
  errors: FormikErrors<AssetDetailProps["values"]>
  handleChange: FormikHandlers["handleChange"]
  touched: FormikState<AssetDetailProps["values"]>["touched"]
  values: Partial<GetActivoByIdDtoProps>
  t: TFunction
}

export const AssetDetail = ({
  errors,
  handleChange,
  touched,
  values,
  t,
}: AssetDetailProps) => (
  <div className='tw-grid tw-grid-cols-4 tw-gap-4'>
    <div className='tw-col-span-4 tw-text-left tw-font-medium'>
      {t("nsAssets.tabDetails.assetDetails")}
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='nombre'
        className='!tw-mb-0 tw-text-left tw-text-nowrap tw-text-ellipsis tw-truncate tw-w-full'
      >
        {t("nsAssets.tabDetails.name")}
      </label>
      <Field
        id='nombre'
        name='nombre'
        type='text'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 ${
          errors.nombre && touched.nombre
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.nombre ?? ""}
      />
      <ErrorMessage
        name='nombre'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-1 tw-text-left'>
      <label
        htmlFor='fechaAdquisicion'
        className='!tw-mb-0 tw-text-left tw-text-nowrap tw-text-ellipsis tw-truncate tw-w-full'
      >
        {t("nsAssets.tabDetails.acquisitionDate")}
      </label>
      <Field
        name='fechaAdquisicion'
        type='text'
        id='fechaAdquisicion'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed ${
          errors.fechaAdquisicion && touched.fechaAdquisicion
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        value={
          values?.fechaAdquisicion
            ? frontendDateFormat(new Date(values.fechaAdquisicion))
            : ""
        }
        disabled
      />
      <ErrorMessage
        name='fechaAdquisicion'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-1 tw-text-left'>
      <label
        htmlFor='tipoInmovilizado'
        className='!tw-mb-0 tw-text-left tw-text-nowrap tw-text-ellipsis tw-truncate tw-w-full'
      >
        {t("nsAssets.tabDetails.assetType")}
      </label>
      <Field
        name='tipoInmovilizado'
        type='text'
        id='tipoInmovilizado'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed ${
          errors.tipoInmovilizado && touched.tipoInmovilizado
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.tipoInmovilizado ?? ""}
        disabled
      />
      <ErrorMessage
        name='tipoInmovilizado'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='numeroCuentaContable'
        className='!tw-mb-0 tw-text-left tw-text-nowrap tw-text-ellipsis tw-truncate tw-w-full'
      >
        {t("nsAssets.tabDetails.assetAccountingAccount")}
      </label>
      <Field
        name='numeroCuentaContable'
        type='text'
        id='numeroCuentaContable'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed ${
          errors.numeroCuentaContable && touched.numeroCuentaContable
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.numeroCuentaContable ?? ""}
        disabled
      />
      <ErrorMessage
        name='numeroCuentaContable'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='numeroCuentaContableContrapartida'
        className='!tw-mb-0 tw-text-left tw-text-nowrap tw-text-ellipsis tw-truncate tw-w-full'
      >
        {t("nsAssets.tabDetails.accountingAccountCounterpart")}
      </label>
      <Field
        name='numeroCuentaContableContrapartida'
        type='text'
        id='numeroCuentaContableContrapartida'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 disabled:tw-bg-neutral-10 disabled:tw-cursor-not-allowed ${
          errors.numeroCuentaContableContrapartida &&
          touched.numeroCuentaContableContrapartida
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.numeroCuentaContableContrapartida ?? ""}
        disabled
      />
      <ErrorMessage
        name='numeroCuentaContableContrapartida'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
  </div>
)
